import React from 'react';
import {ApTimelineAudioWaveform} from '@accurate-player/accurate-player-components-external';

import './Waveform.scss';

ApTimelineAudioWaveform.register();

export interface WaveformProps {
    setWaveformRef: () => void;
}

export default function Waveform(props: WaveformProps) {
    const {setWaveformRef} = props;
    
    return (
        <div className="waveform-container">
            <ap-timeline-audio-waveform
                class="waveform"
                slot="content"
                ref={setWaveformRef}
                height={25}
                sample-min={-127}
                sample-max={127}
                origo={0}
                type="fill"
                mirror
            />
        </div>
    );
}
